import {Application} from './Application';

export type PreregisteredAgent = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
};

export type PreregisteredAgentFilter = {
  firstName: string;
  lastName: string;
  email: string;
};

export const EmptyPreregisteredAgentFilter = {
  firstName: '',
  lastName: '',
  email: '',
  applicationId: Application.Agent,
};
